import React from "react";

interface Props {
  title: string;
  subtitle?: string;
  onClose: () => void;
  footer: React.ReactNode;
  children: React.ReactNode;
  width?: number;
}

export default function SideDrawer({
  title,
  subtitle,
  onClose,
  footer,
  children,
  width = 460,
}: Props) {
  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1040 }}
        onClick={onClose}
      />
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width,
          height: "100vh",
          background: "#fff",
          borderLeft: "1px solid #dee2e6",
          boxShadow: "-4px 0 24px rgba(0,0,0,.12)",
          display: "flex",
          flexDirection: "column",
          zIndex: 1050,
        }}
      >
        <div className="d-flex align-items-center justify-content-between p-4 border-bottom flex-shrink-0">
          <div>
            <h5 className="fw-bold mb-0">{title}</h5>
            {subtitle && <small className="text-muted">{subtitle}</small>}
          </div>
          <button type="button" className="btn-close" onClick={onClose} />
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "24px" }}>
          {children}
        </div>

        <div className="p-4 border-top d-flex gap-2 justify-content-end flex-shrink-0">
          {footer}
        </div>
      </div>
    </>
  );
}
